<template>
  <!-- 管理员-数据面板 -->
  <div class="main-css">
    <div class="main-box">
      <div class="left-box">
        <!-- 第一行 -->
        <div class="one-line">
          <div class="one-line-box1">
            <div class="one-line-title">
              {{ $t("NumberMedicalInstitutions") }}
            </div>
            <div class="one-line-main">{{ totalNumber }}</div>
          </div>
          <div class="one-line-box2">
            <div class="one-line-title">
              {{ $t("NumberEducationalInstitutions") }}
            </div>
            <div class="one-line-main">{{ edNumber }}</div>
          </div>
          <div class="one-line-box3">
            <div class="one-line-title">{{ $t("applicationCaseNumber") }}</div>
            <div class="one-line-main">{{ applyNmuber }}</div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="two-line">
          <div class="two-line-box">
            <div class="two-line-title">{{ $t("NumberJobOffers") }}</div>
            <div class="two-line-main">{{ recruitNumber }}</div>
          </div>
          <div class="two-line-box">
            <div class="two-line-title">{{ $t("NumberOfPersonnel") }}</div>
            <div class="two-line-main">{{ reNumber }}</div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="other-line">
          <div class="other-line-box">
            <div class="other-line-title">
              <span class="title-main">{{ $t("NoticeToInstitutions") }}</span>
              <div class="line-el-select">
                <el-date-picker
                  v-model="timeSearch1"
                  type="date"
                  :placeholder="$t('registerDayselsect')"
                  clearable
                  value-format="yyyy-MM-dd"
                  @change="timeOne"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="scroll-box-hidden">
              <div class="other-line-scroll">
                <div
                  class="other-scroll-box"
                  v-for="(item, index) in messageShowList"
                  :key="index + 'p'"
                  @click="handleSeeMore"
                >
                  <div class="other-scroll-left">
                    <div class="other-scroll-title">
                      {{ item.matterName }}
                    </div>
                    <div class="other-scroll-time">{{ item.matterTime }}</div>
                  </div>
                  <!-- <div class="other-scroll-right">
                    <img src="./assets/Vector.png" alt="" />
                    <img src="./assets/Group 3.png" alt="" />
                  </div> -->
                </div>
              </div>
            </div>

            <!-- <div class="four-line-box">See All Announcement</div> -->
          </div>
        </div>
      </div>
      <div class="right-box">
        <!-- 右1 -->
        <div class="right-top-box">
          <div class="right-top-title">{{ $t("serviceRequest") }}</div>
          <div class="right-top-box-scroll">
            <div class="scroll-box-right">
              <div
                class="right-top-main"
                v-for="(item, index) in systemMsgShowList"
                :key="index + 'o'"
              >
                <div class="right-top-main-top">{{ item.matterTime }}</div>
                <div class="right-top-main-bottom">{{ item.matterName }}</div>
              </div>
            </div>
          </div>
          <div class="right-bottom-box">
            <div class="right-bottom-left">
              Today you makes {{ systemMsgShowListNumber }} Activity
            </div>
            <div class="right-bottom-button">
<!--              <button @click="handleSeeMore" style="cursor:pointer">-->
<!--                {{ $t("seeMore") }}-->
<!--              </button>-->
            </div>
          </div>
        </div>
        <!-- 右2 -->
        <div class="right-two-box">
          <div class="other-line-title">
            <span class="title-main">{{ $t("MattersProcessed") }}</span>
            <div class="line-el-select">
              <el-date-picker
                v-model="timeSearch2"
                type="date"
                :placeholder="$t('registerDayselsect')"
                clearable
                value-format="yyyy-MM-dd"
                @change="timeTwo"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="right-two-main-box">
            <div class="scroll-box-hidden1">
              <div class="other-line-scroll1">
                <div class="right-main-title" v-if="applyExamine.length !== 0">
                  {{ $t("applicationReview") }}
                </div>
                <div
                  class="other-scroll-box1"
                  v-for="(item, index) in applyExamine"
                  :key="index + 'h'"
                  @click="goToApply"
                >
                  <div class="other-scroll-left">
                    <div class="other-scroll-title">{{ item.matterName }}</div>
                    <div class="other-scroll-time">{{ item.matterTime }}</div>
                  </div>
                  <!-- <div class="other-scroll-right1">
                    <img src="./assets/Group 3.png" alt="" />
                  </div> -->
                </div>
                <div
                  class="right-main-title"
                  v-if="educationlExamine.length !== 0"
                >
                  {{ $t("medicalInstitutionAudit") }}
                </div>
                <div
                  class="other-scroll-box1"
                  v-for="(item, index) in educationlExamine"
                  :key="index + 'm'"
                  @click="goToMedicalList"
                >
                  <div class="other-scroll-left">
                    <div class="other-scroll-title">
                      {{ item.matterName }}
                    </div>
                    <div class="other-scroll-time">{{ item.matterTime }}</div>
                  </div>
                  <!-- <div class="other-scroll-right1">
                    <img src="./assets/Group 3.png" alt="" />
                  </div> -->
                </div>
                <div class="right-main-title" v-if="jobExamine.length !== 0">
                  {{ $t("recruitmentReview") }}
                </div>
                <div
                  class="other-scroll-box1"
                  v-for="(item, index) in jobExamine"
                  :key="index + 'g'"
                  @click="goToCaseManagement"
                >
                  <div class="other-scroll-left">
                    <div class="other-scroll-title">
                      {{ item.matterName }}
                    </div>
                    <div class="other-scroll-time">{{ item.matterTime }}</div>
                  </div>
                  <!-- <div class="other-scroll-right1">
                    <img src="./assets/Group 3.png" alt="" />
                  </div> -->
                </div>
                <div
                  class="right-main-title"
                  v-if="medicalExamine.length !== 0"
                >
                  {{ $t("educationalInstitutionAudit") }}
                </div>
                <div
                  class="other-scroll-box1"
                  v-for="(item, index) in medicalExamine"
                  :key="index + ','"
                  @click="goToEducationalList"
                >
                  <div class="other-scroll-left">
                    <div class="other-scroll-title">
                      {{ item.matterName }}
                    </div>
                    <div class="other-scroll-time">{{ item.matterTime }}</div>
                  </div>
                  <!-- <div class="other-scroll-right1">
                    <img src="./assets/Group 3.png" alt="" />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="four-line-box1">Creat a New Schedule</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  getApplyNumber,
  getMedicalNumber,
  getEducationNumber,
  getPersonnelNumber,
  getRecruitNumber,
  handleMatter,
  messageShow,
  systemMsgShow
} from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "",
  components: {},
  data() {
    return {
      selectValue: "",
      selectOptions: "",
      selectValue2: "",
      selectOptions2: "",
      totalNumber: 0,
      edNumber: 0,
      reNumber: 0,
      recruitNumber: 0,
      applyNmuber: 0,
      applyExamine: [],
      educationlExamine: [],
      jobExamine: [],
      medicalExamine: [],
      messageShowList: [],
      timeSearch1: "",
      timeSearch2: "",
      systemMsgShowList: [],
      systemMsgShowListNumber: 0
    };
  },
  created() {
    this.applyNumberGet();
    this.medicalNumberGet();
    this.personnelNumberGet();
    this.educationNumberGet();
    this.recruitNumberGet();
    this.matterHandle();
    this.getMessageShow();
    this.getSystemMsgShow();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.applyNumberGet();
        this.medicalNumberGet();
        this.personnelNumberGet();
        this.educationNumberGet();
        this.recruitNumberGet();
        this.matterHandle();
        this.getMessageShow();
        this.getSystemMsgShow();
      }
    },
    //看更多
    handleSeeMore() {
      this.$router.push("/administratorInformationManagement");
    },
    //跳转应聘管理
    goToApply() {
      this.$router.push("/administratorApplicationManagement");
    },
    //跳转医疗管理
    goToMedicalList() {
      this.$router.push("/administratorsViewMedicalList");
    },
    //跳转案件管理
    goToCaseManagement() {
      this.$router.push("/administratorCaseManagement");
    },
    //跳转教育管理
    goToEducationalList() {
      this.$router.push("/administratorViewEducationalList");
    },
    ////申请人数
    applyNumberGet() {
      getApplyNumber()
        .then(res => {
          console.log("-----申请人数接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.applyNmuber = aesFecInfo.totalNumber;
          }
        })
        .catch(res => {
          console.log("-----申请人数接口-----");
          console.log(res);
        });
    },
    // 医疗机构数
    medicalNumberGet() {
      getMedicalNumber()
        .then(res => {
          console.log("-----医疗机关数-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNumber = aesFecInfo.totalNumber;
          }
        })
        .catch(res => {
          console.log("-----医疗机关数-----");
          console.log(res);
        });
    },
    //教育机构数
    educationNumberGet() {
      getEducationNumber()
        .then(res => {
          console.log("-----教育机关数-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.edNumber = aesFecInfo.totalNumber;
          }
        })
        .catch(res => {
          console.log("-----教育机关数-----");
          console.log(res);
        });
    },
    //人才数
    personnelNumberGet() {
      getPersonnelNumber()
        .then(res => {
          console.log("-----人才数-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.reNumber = aesFecInfo.totalNumber;
          }
        })
        .catch(res => {
          console.log("-----人才数-----");
          console.log(res);
        });
    },
    //求人案件数
    recruitNumberGet() {
      getRecruitNumber()
        .then(res => {
          console.log("-----求人案件数-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.recruitNumber = aesFecInfo.totalNumber;
          }
        })
        .catch(res => {
          console.log("-----求人案件数-----");
          console.log(res);
        });
    },
    //处理事项
    matterHandle() {
      if (this.timeSearch2 === "") {
        var fakeInfo = {
          time: ""
        };
      } else if (this.timeSearch2 === null) {
        var fakeInfo = {
          time: ""
        };
      } else if (this.timeSearch2 === undefined) {
        var fakeInfo = {
          time: ""
        };
      } else {
        var fakeInfo = {
          time: this.timeSearch2
        };
      }
      handleMatter(fakeInfo)
        .then(res => {
          console.log("-----处理事项口返回值-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.applyExamine = aesFecInfo.applyExamine;
            this.educationlExamine = aesFecInfo.educationlExamine;
            this.jobExamine = aesFecInfo.jobExamine;
            this.medicalExamine = aesFecInfo.medicalExamine;
          }
        })
        .catch(res => {
          console.log("-----处理事项口返回值-----");
          console.log(res);
        });
    },
    //互动消息
    getMessageShow() {
      if (this.timeSearch1 === "") {
        var fakeInfo = {
          time: ""
        };
      } else if (this.timeSearch1 === null) {
        var fakeInfo = {
          time: ""
        };
      } else if (this.timeSearch1 === undefined) {
        var fakeInfo = {
          time: ""
        };
      } else {
        var fakeInfo = {
          time: this.timeSearch1
        };
      }
      console.log(fakeInfo);
      messageShow(fakeInfo)
        .then(res => {
          console.log("-----互动消息接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.messageShowList = aesFecInfo;
          }
        })
        .catch(res => {
          console.log("-----互动消息接口-----");
          console.log(res);
        });
    },
    //时间选择
    timeOne() {
      this.getMessageShow();
    },
    //时间选择
    timeTwo() {
      this.matterHandle();
    },
    // 系统信息未读查看
    getSystemMsgShow() {
      systemMsgShow()
        .then(res => {
          console.log("-----系统信息未读查看接口信息-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.systemMsgShowList = aesFecInfo;
            this.systemMsgShowListNumber = aesFecInfo.length;
          }
        })
        .catch(res => {
          console.log("-----系统信息未读查看接口信息-----");
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  min-height: calc(100%-60px);
  background: #fff;
  overflow: hidden;
}

.main-box {
  min-width: 1100px;
  height: 100%;
  padding: 30px 30px 70px 50px;
  box-sizing: border-box;
  margin: 0 auto;
}

.left-box {
  width: 50%;
  height: 100%;
  float: left;
  margin-right: 4%;
}

.one-line {
  height: 150px;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;
}

.one-line-box1 {
  width: 30%;
  height: 136px;
  background: #ffefe7;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.one-line-box2 {
  width: 30%;
  height: 136px;
  background: #e8f0fb;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.one-line-box3 {
  width: 30%;
  height: 136px;
  background: #fdebf9;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.one-line-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}

.one-line-main {
  font-weight: 500;
  font-size: 36px;
  line-height: 28px;
}

.two-line {
  width: 100%;
  height: 200px;
  background: #fff;
  display: flex;
  justify-content: space-between;
}

.two-line-box {
  padding: 20px;
  box-sizing: border-box;
  width: 45%;
  height: 190px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.two-line-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}
.right-two-main-box {
  width: 100%;
}

.two-line-main {
  font-weight: 500;
  font-size: 48px;
  line-height: 28px;
}

.other-line {
  width: 100%;
  height: 340px;
  background: #fff;
  overflow: hidden;
  margin-top: 10px;
}

.other-line-box {
  width: 100%;
  height: 334px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px 22px;

  position: relative;
  box-sizing: border-box;
}

.other-line-title {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.title-main {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 40px;
}

.line-el-select {
  overflow: hidden;
  width: 145px;
}

/* .line-el-select /deep/ .el-select {
  width: 145px;
  height: 27px;
  background: #ffffff;
  border: 1px solid transparent;
  border-radius: 4px;
} */

.line-el-select /deep/ .el-input__inner {
  border: 1px solid #efefef;
  border-radius: 4px;
  width: 145px;
  height: 27px;
}

.line-el-select /deep/ .el-input__icon {
  line-height: 0;
}

.other-line-scroll {
  height: 210px;
  width: 100%;
  overflow-y: scroll;
}

.scroll-box-hidden {
  width: 100%;
  overflow: hidden;
}

.other-scroll-box {
  width: 600px;
  height: 68px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 8px;
}

.other-scroll-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.other-scroll-left {
  width: 405px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #303030;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.other-scroll-time {
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #686868;
}

.other-scroll-right {
  width: 100px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.other-scroll-right img {
  cursor: pointer;
}

.four-line-box {
  width: 640px;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 10px 10px;
  border-top: 1px solid #e0e0e0;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 50px;
  color: #51abff;
  text-align: center;
}

.right-box {
  width: 42%;
  height: 100%;
  float: left;
  margin-left: 30px;
}

.right-top-box {
  width: 100%;
  height: 258px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    #161e54;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.right-top-box-scroll {
  width: 100%;
  overflow: hidden;
}

.scroll-box-right {
  height: 130px;
  width: 100%;
  overflow-y: scroll;
}

.right-top-title {
  padding: 10px 10px 10px 24px;
  width: 100%;
  height: 48px;
  background: #1b204a;
  line-height: 48px;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
}

.right-top-main {
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 10px 24px;
  margin-bottom: 5px;
}

.right-top-main-top {
  width: 100%;
  height: 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.right-top-main-bottom {
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #ffffff;
  margin-top: 5px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.right-bottom-box {
  height: 50px;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 10px 10px 24px;
  overflow: hidden;
}

.right-bottom-left {
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  float: left;
  color: #ffffff;
}

.right-bottom-button {
  float: left;
}

.right-bottom-button button {
  padding: 10px 16px;
  box-sizing: border-box;
  width: 139px;
  height: 38px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  margin-left: 55px;
  cursor: pointer;
}

.right-two-box {
  width: 100%;
  height: 415px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 10px 21px;
  box-sizing: border-box;
  position: relative;
}

.right-main-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  color: #686868;
}

.right-main-box-css {
  padding: 10px 16px;
  box-sizing: border-box;
  width: 387px;
  height: 64px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.other-line-scroll1 {
  height: 298px;
  width: 98%;
  overflow-y: scroll;
}

.scroll-box-hidden1 {
  width: 100%;
  overflow: hidden;
}

.other-scroll-box1 {
  width: 95%;
  height: 68px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 8px;
}

.other-scroll-left1 {
  width: 283px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #303030;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.other-scroll-right1 {
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.other-scroll-right1 img {
  cursor: pointer;
}

.four-line-box1 {
  width: 450px;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 10px 10px;
  border-top: 1px solid #e0e0e0;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 50px;
  color: #51abff;
  text-align: center;
}

.line-el-select /deep/ .el-date-editor {
  width: 145px;
  height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminDataPanel/index.vue